import styled from 'styled-components'
import { disableImageDraggableStyleMixin } from 'styles/mixins'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const SearchNoResultContainer = styled.div`
  text-align: center;
  padding: 32px 0px 22px 0px;

  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    padding-bottom: 200px;
  }
`

export const SearchNoResultImage = styled.img`
  width: 128px;
  margin-bottom: 20px;
  min-height: 106px;
  ${disableImageDraggableStyleMixin()}
`

export const SearchNoResultTextsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
